import { useTranslation } from 'react-i18next'
import { LuArrowRight } from 'react-icons/lu'
import { MdOutlineCorporateFare, MdOutlineLocalShipping } from 'react-icons/md'
import { Button, RadioGroup } from '@asus-common/fe-ui-shadcn'
import { AccessProfile } from '@/features/auth/lib/utils'
import { RadioCard } from './RadioCard'

interface ProfileStepProps {
  profile: AccessProfile | null
  onProfileChange: (value: AccessProfile) => void
  onContinue: () => void
}

export function ProfileStep({
  profile,
  onProfileChange,
  onContinue,
}: ProfileStepProps) {
  const { t } = useTranslation('reset-password')

  return (
    <div className="mt-6 flex flex-col gap-6">
      <RadioGroup
        value={profile ?? ''}
        onValueChange={value => onProfileChange(value as AccessProfile)}
        className="flex justify-center gap-6"
        aria-label={t('modal.profile_title')}
      >
        <RadioCard
          id="internal-profile"
          value={AccessProfile.Internal}
          icon={MdOutlineCorporateFare}
          title={t('modal.internal_user')}
          description={t('modal.internal_description')}
          selected={profile === AccessProfile.Internal}
        />

        <RadioCard
          id="external-profile"
          value={AccessProfile.External}
          icon={MdOutlineLocalShipping}
          title={t('modal.external_user')}
          description={t('modal.external_description')}
          selected={profile === AccessProfile.External}
        />
      </RadioGroup>

      <div className="flex justify-end">
        <Button
          type="button"
          variant="solid"
          status="primary"
          size="md"
          disabled={!profile}
          onClick={onContinue}
          endIcon={<LuArrowRight />}
        >
          {t('modal.advance')}
        </Button>
      </div>
    </div>
  )
}
